import { render, staticRenderFns } from "./AddNewFamily.vue?vue&type=template&id=75eeae9e&scoped=true&"
import script from "./AddNewFamily.vue?vue&type=script&lang=js&"
export * from "./AddNewFamily.vue?vue&type=script&lang=js&"
import style0 from "./AddNewFamily.vue?vue&type=style&index=0&id=75eeae9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eeae9e",
  null
  
)

export default component.exports